<template>
    <ContainerContent
        class="mb-8"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Return Policy</h1>
            </v-col>
        </v-row>

        <ReturnsContent
            :brand-domain-name="brandDomainName"
        ></ReturnsContent>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    const ReturnsContent = defineAsyncComponent(() => import('~/components/account/returns/ReturnsContent/ReturnsContent.vue'));

    definePageMeta({
        scrollToTop: true,
        alias: [
            '/support/returns/'
        ]
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;
    const brandDomainName = $config.public.brand.domainNameTitle;

    useHead({
        title: `Return Policy | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Return Policy'
            }
        ]
    });
</script>

<style lang="scss" scoped>
address {
    width: fit-content;
}
</style>
